import CommonUtils from '@/resources/utils/common-utils'
import API from '@/config/api'

const pageApi = {
  state: {

  },

  mutations: {
    getInsurancePolicyList(state, data) {
      data.url = API.insurancePolicy.getInsurancePolicyList
      CommonUtils.GetRequest(data)
    },
    uploadInsurancePolicyFile(state, data) {
      data.url = API.insurancePolicy.uploadInsurancePolicyFile
      CommonUtils.PostRequest(data)
    },
    editSalesPlatform(state, data) {
      data.url = API.insurancePolicy.editSalesPlatform
      CommonUtils.GetRequest(data)
    },
    getUnmatchedProduct(state, data) {
      data.url = API.insurancePolicy.getUnmatchedProduct
      CommonUtils.GetRequest(data)
    },
    getSalesPlatforms(state, data) {
      data.url = API.insurancePolicy.getSalesPlatforms
      CommonUtils.GetRequest(data)
    }
  }
}

export default pageApi



// WEBPACK FOOTER //
// ./src/store/modules/insurancePolicy.js